
import type { RegularFilterConfig } from '@empathybroker/tsclient-play/dist/models/instance/filters/regular-filter-config'
import type { RankingElement } from '@empathybroker/tsclient-play/dist/models/ranking-element'
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import RankingElementAside from './ranking-element-aside.component.vue'

export default defineComponent({
  name: 'ProductRankingElementAside',
  components: {
    RankingElementAside,
  },
  props: {
    element: {
      type: Object as PropType<RankingElement>,
      required: true,
    },
    filterConfigs: {
      type: Array as PropType<Array<RegularFilterConfig>>,
      required: true,
    },
    messages: {
      type: Object,
      required: true,
    },
  },
})
